module.exports = __webpack_public_path__ + "static/img/save-20.ac88a131.svg";